import { Component, OnInit, inject } from '@angular/core';
import { PrintPdfFilesService } from '../print-pdf-files.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-ptr-guidelines',
    templateUrl: './ptr-guidelines.component.html',
    styleUrls: ['./ptr-guidelines.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class PtrGuidelinesComponent implements OnInit {
  pdfGenService = inject(PrintPdfFilesService);


  ngOnInit(): void {
  }

}
